import { render, staticRenderFns } from "./mobile-part-3.vue?vue&type=template&id=e010d6ec&scoped=true"
import script from "./mobile-part-3.vue?vue&type=script&lang=js"
export * from "./mobile-part-3.vue?vue&type=script&lang=js"
import style0 from "./mobile-part-3.vue?vue&type=style&index=0&id=e010d6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e010d6ec",
  null
  
)

export default component.exports